import React from 'react';
import { Field, NumericInput, RadioGroup } from '../../../../Core';
import { ListFieldSection } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { WorksheetEquipmentDropdown, IWithWorksheetInjectedProps } from '../../../Core';
import { useSelector } from 'react-redux';
import PreparationAsReceivedWaterContentSection from './PreparationAsReceivedWaterContentSection';
import { WorksheetBalanceFieldSet } from '../../../Core/WorksheetEquipment';
import { pipe } from 'Lib/Hooks/Selectors';

let PreparationWetSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const wetPreparationMethod = useSelector(createWorksheetSelector!('Preparation.WetPreparationMethod'));
  const ovenDried = useSelector(pipe(createWorksheetSelector!('Preparation.MaterialDriedBy'), (d) => d === 'Oven'));
  const materialWashed = useSelector(
    pipe(createWorksheetSelector!('Preparation.OversizeMaterialRemovedBy'), (d) => d === 'Wash')
  );

  return (
    <>
      <ListFieldSection heading="Wet Preparation">
        <Field
          input={<RadioGroup />}
          label="Wet Preparation Method"
          name="Preparation.WetPreparationMethod"
          options={[
            {
              label: 'A',
              value: 'A',
            },
            {
              label: 'B',
              value: 'B',
            },
          ]}
        />
        <WorksheetBalanceFieldSet label="Balance" name="Preparation.Balance" />
      </ListFieldSection>
      {wetPreparationMethod === 'A' && (
        <ListFieldSection>
          <Field
            input={<RadioGroup />}
            name="Preparation.MaterialDriedBy"
            label="Initial Drying"
            options={[
              { label: 'Oven Dried', value: 'Oven' },
              { label: 'Air Dried', value: 'Air' },
            ]}
          />
          <Field
            input={<WorksheetEquipmentDropdown />}
            equipmentType="oven"
            label="Oven"
            name="Preparation.Oven"
            visible={ovenDried}
          />
          <Field
            input={<RadioGroup />}
            name="Preparation.PreparationProcessingMethod"
            label="Processing Method"
            freeEntry={true}
            freeEntryLabel="Other"
            options={[
              { label: 'Mortar & Pestle', value: 'Mortar & Pestle' },
              { label: 'Rollerdrum', value: 'Rollerdrum' },
            ]}
          />
          <Field input={<NumericInput />} name="Preparation.OriginalSampleMass" label="Original Mass of Sample" />
        </ListFieldSection>
      )}
      {wetPreparationMethod === 'B' && <PreparationAsReceivedWaterContentSection />}
      <ListFieldSection heading={wetPreparationMethod === 'A' ? undefined : 'Washing'}>
        <Field
          visible={wetPreparationMethod === 'B'}
          input={<RadioGroup />}
          label="Material Washed over No. 40 (425 µm) Sieve?"
          name="Preparation.OversizeMaterialRemovedBy"
          options={[
            { value: 'Wash', label: 'Yes' },
            { value: 'None', label: 'No' },
          ]}
        />
        <Field
          input={<WorksheetEquipmentDropdown />}
          label="No. 40 (425 µm) Sieve"
          equipmentType="sieve"
          name="Preparation.OversizeSieve"
          visible={materialWashed || wetPreparationMethod === 'A'}
          queryParams={{ SieveSize: '0.000425 m' }}
        />
        <Field
          input={<NumericInput />}
          name="Preparation.PassingPortionMass"
          label="Mass of Passing Portion Selected for Test"
        />
      </ListFieldSection>
    </>
  );
};

PreparationWetSection = withInjectedProps(PreparationWetSection);

export { PreparationWetSection };
export default PreparationWetSection;
